<template>
  <div class="mypooq-inner-wrap">
    <using-break-down-list viewMode="singular"/>
  </div>
</template>

<script>
import UsingBreakDownList from '@/components/mypooq/UsingBreakDownList'
import cookie from '@/common/utils/cookie'
import { titleTagNameChange } from '@/common/utils/common'
export default {
  components: {
    UsingBreakDownList
  },
  data () {
    return {
      isPooqzone: cookie.isWavveOn()
    }
  },
  created () {
    titleTagNameChange('개별구매 : 웨이브 MY')
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/my.scss"></style>
